import type {
  SaveBarIsDirtyState,
  SaveBarIsSavingState,
} from "./app-save-bar.type";

import { atom } from "jotai";

export const saveBarIsDirty = atom<SaveBarIsDirtyState>(false);

export const saveBarIsSaving = atom<SaveBarIsSavingState>(false);
